exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1f0757ee] .el-dialog{border-radius:6px;width:447px}.img[data-v-1f0757ee]{width:40px;height:40px;margin-right:8px}.auth-body[data-v-1f0757ee]{padding:14px}.auth[data-v-1f0757ee]{padding:9px 16px 9px 10px}.card[data-v-1f0757ee]{width:100%;height:98px;background-color:#fff}.auth .iconIos[data-v-1f0757ee]{font-size:40px;margin-right:10px;color:#001529}.auth .text[data-v-1f0757ee]{font-weight:400;color:#000;font-size:18px}.auth .text .code[data-v-1f0757ee]{display:inline-block;margin-top:8px;font-size:14px;color:rgba(0,0,0,0.5)}.block[data-v-1f0757ee]{display:block !important}.tips[data-v-1f0757ee]{font-size:12px}\n", ""]);

// exports
